export default {
  name: 'subHeader',
  methods: {
  },
  data () {
    return {
      n1: false
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.isMobile
    },
    navList () {
      return this.$store.state.navList
    }
  }
}

